'use strict';

import { tns } from "tiny-slider/src/tiny-slider";

const slider =  {
    init: function(){
        slider.blocSlider();
        slider.widgetSlider();
        slider.careerSlider();
        slider.ytSlider();

        // homepage sliders
        slider.mainSlider();    // HP main
        slider.jobSlider();     // HP slide 2
    },

    blocSlider: function() {
        if (document.querySelector('.bSlider_list')) {
            let blocSlider = tns({
                container: '.bSlider_list',
                mode: "gallery",
                items: 1,
                autoplay: false,
                mouseDrag: true,
                controls: false,
                autoplayText: false,
                autoplayButton: false,
                speed: 500,
                loop: false,
            });
        }
    },

    widgetSlider: function() {
        const sliderElements = document.querySelectorAll('.bSlider_list');
    
        sliderElements.forEach(sliderElement => {
            const blocSlider = tns({
                container: sliderElement,
                mode: "gallery",
                items: 1,
                autoplay: false,
                mouseDrag: true,
                controls: false,
                autoplayText: false,
                autoplayButton: false,
                speed: 500,
                loop: false,
            });
        });
    },

    careerSlider: function () {
        const sliderElement = document.querySelector('.pHead_slider-list');
        //const timebarInner = document.querySelector('.pHead_slider-timebar-inner');
        if (!sliderElement /*|| !timebarInner */) return;

        // Fonction pour gérer l'animation de la barre de progression
        /*const resetTimebar = () => {
            timebarInner.style.transition = 'none'; // Désactive la transition
            timebarInner.style.width = '0%'; // Réinitialise la largeur
            setTimeout(() => {
                timebarInner.style.transition = 'width 5s ease'; // Réactive la transition
                timebarInner.style.width = '100%'; // Anime vers 100%
            }, 50); // Petite pause pour permettre la réinitialisation
        };*/

        // Initialisation du slider
        const careerSlider = tns({
            container: '.pHead_slider-list',
            mode: "gallery",
            items: 1,
            autoplay: true,
            mouseDrag: true,
            controls: false,
            autoplayText: false,
            autoplayButton: false,
            autoplayButtonOutput: false,
            speed: 500,
            loop: false,
            rewind: true,
            autoplayTimeout: 5000, // 8 secondes pour correspondre à la barre
            //onInit: resetTimebar, // Démarre l'animation au chargement
        });

        // Réinitialise la barre à chaque fin de transition
        //careerSlider.events.on('transitionEnd', resetTimebar);
    },

    ytSlider: function () {
        const sliderElement = document.querySelector('.pBody_ytslider-list');
        if (!sliderElement) return;

        // Vérification du nombre d'enfants (slides)
        const slides = sliderElement.children;
        if (slides.length <= 1) {
            // Si une seule vidéo, ne pas initialiser le slider
            sliderElement.classList.add('single-video'); // Optionnel : pour du style si nécessaire
            return;
        }

        // Initialisation du slider si plus d'une vidéo
        const ytSlider = tns({
            container: '.pBody_ytslider-list',
            mode: "gallery",
            items: 1,
            autoplay: false,
            mouseDrag: true,
            controls: false,
            autoplayText: false,
            autoplayButton: false,
            autoplayButtonOutput: false,
            speed: 500,
            loop: false,
            rewind: false
        });
    },

    // main slider homepage
    mainSlider: function() {   
        let homeslider = document.querySelector('.mainSlider_wrap');
        if (homeslider) {

            // on mobile device, move footer to main slider
            if(window.matchMedia("(max-width: 1099px)").matches) {
                let newSlide = document.createElement('div');
                newSlide.setAttribute('class', 'mainSlide mainSlide_7');
                
                let newDiv = document.createElement('div');
                newDiv.setAttribute('class', 'fullHeight');
                
                newSlide.append(newDiv);
                
                let slider = document.querySelector('.mainSlider_wrap');
                slider.appendChild(newSlide);

                let footer = document.querySelector('.footer');
                let finalPlace = document.querySelector('.mainSlide_7 .fullHeight');
                finalPlace.append(footer);
            }

            // init slider
            let home_slider = tns({
                container: ".mainSlider_wrap",
                mode: "gallery",
                items: 1,
                autoplay: false,
                autoHeight: false,
                mouseDrag: false,
                touch: false,
                controls: false,
                autoplayText: false,
                autoplayButton: false,
                animateIn: "slideTop",
                animateOut: "fadingOut",
                speed: 800,
                loop: false,
                preventActionWhenRunning: true
            });

            let total = document.querySelectorAll('.mainSlide').length;
            let index = home_slider.getInfo().index + 1;
            index == total ? disableScroll(false) : disableScroll(true);
            slider.thermogpraphVar(home_slider.getInfo().index);

            // listen scroll on desktop
            window.addEventListener("mousewheel", wheel, true);     // IE9, Chrome, Safari, Opera
            window.addEventListener("DOMMouseScroll", wheel, true); // Firefox

            // listen touch on mobile and tablet
            var ts;
            window.addEventListener("touchstart", function(e) {
                // console.log(e.touches[0].clientY);
                ts = e.touches[0].clientY;
            });
            window.addEventListener("touchmove", function(e) {
                // console.log(e);
                var te = e.changedTouches[0].clientY;
                ts > te ? home_slider.goTo('next') : home_slider.goTo('prev');
            });

			function wheel(event) {
                var delta = 0;
                var e = window.event || e;
				if (event.wheelDelta) { /* IE/Opera. */
					delta = event.wheelDelta / 120;
				} else if (event.detail) { /* Mozilla case. */
					delta = -event.detail / 3;
				}
				if (delta) {
					handle(delta);
                }
				// if (event.preventDefault) {
                //     event.currentTarget.blur()
                // }
                //event.preventDefault();
				//event.returnValue = false;
            }

			function handle(delta) {
                // Si on n'est pas en train de regarder un webdoc
				if ( !document.querySelector('.page').classList.contains('fullScreen') ) {
                    
                    // console.log(index, total);
                    
                    // scroll vers le bas
                    if ( delta < -0.6 ) {
                        home_slider.goTo('next');
                    }
                    
                    // scroll vers le haut
                    else if ( delta > 0.6 ) {
                        home_slider.goTo('prev');
                    }

                    let total = document.querySelectorAll('.mainSlide').length;
                    let index = parseInt(home_slider.getInfo().index) + 1;
                    index == total ? disableScroll(false) : disableScroll(true);

                    if(!document.querySelector('html').classList.contains('disableScroll')) {
                        if ( delta < -0.6 ) {
                            window.scrollTo(0, document.body.scrollHeight);
                        }
                        // scroll vers le haut
                        else if ( delta > 0.6 ) {
                            home_slider.goTo('last');
                        }
                    }
                } 
            }
            
            function disableScroll(toggle) {
                let html = document.querySelector('html');
                let body = document.body;
                let height = window.innerHeight;

                if(toggle == true) {
                    html.style.height = height + 'px';
                    body.style.height = height + 'px';
                    html.classList.add('disableScroll');
                }
                else {
                    setTimeout(() => {
                        html.style.height = '';
                        body.style.height = '';
                        html.classList.remove('disableScroll');
                    }, 800);
                }
            }
            home_slider.events.on('indexChanged', function(index) {
                slider.thermogpraphVar(index.index);
            });

            home_slider.events.on('transitionStart', function() {
                let btnStop = document.querySelectorAll('.stopVideo');
                btnStop.forEach(btn => {
                    btn.click();
                });
            });
            
            home_slider.events.on('transitionEnd', function() {
                let activeSlide = document.querySelector('.mainSlide.tns-slide-active');
                if( activeSlide.classList.contains('video') ) {
                    activeSlide.querySelector('.btn_play').click();
                }
            });

            setTimeout(() => {
                let activeSlide = document.querySelector('.mainSlide.tns-slide-active');
                if( activeSlide.classList.contains('video') )
                    activeSlide.querySelector('.btn_play').click();
            }, 500);

            slider.setFullHeight();

		}
    },
    
    setFullHeight: function() {
        let fullHeight = document.querySelectorAll('.fullHeight');
        let realHeight = document.documentElement.clientHeight;
        let heightSet = 0;
        let gap = window.matchMedia("(max-width: 767px)").matches ? 80 : 114;
        if(fullHeight && heightSet != realHeight) {
            fullHeight.forEach(element => {
                element.style.height = realHeight - gap + 'px';
                heightSet = realHeight;
            });
        }
    },

    // slider homepage / métiers
    jobSlider: function() {
        let jobSlider = document.querySelector('.job_slider');
        let jobBtn = document.querySelectorAll('.job_btn');
        
        if (jobSlider) {
            let job_slider = tns({
                container: '.job_slider',
                mode: "gallery",
                items: 1,
                autoplay: false,
                mouseDrag: false,
                controls: false,
                autoplayText: false,
                autoplayButton: false,
                speed: 500,
                loop: false,
            });
            
            jobBtn.forEach(btn => {
                
                if(window.matchMedia("(max-width: 1099px)").matches) {
                    btn.addEventListener('click', function(event) {
                        event.preventDefault();
                        if( btn.classList.contains('selected') ) {
                            document.location = this.href;
                        }
                        else {
                            let id = this.dataset.slide;
                            job_slider.goTo(id);
                            
                            let jobBtnSelected = document.querySelector('.job_btn.selected');
                            if(jobBtnSelected)
                            jobBtnSelected.classList.remove('selected');
                            
                            btn.classList.add('selected');
                        }
                    });
                }
                else {
                    btn.addEventListener('mouseenter', function() {
                        let id = btn.dataset.slide;
                        job_slider.goTo(id);
                        
                        let jobBtnSelected = document.querySelector('.job_btn.selected');
                        if(jobBtnSelected)
                            jobBtnSelected.classList.remove('selected');
    
                        btn.classList.add('selected');
                    });
                }
            });
        }
    },
    thermogpraphVar:function(index) {
		index = index.toString();
		
        switch (index) {
            case '0':
                window.CE_SNAPSHOT_NAME = "HP - 1 - Slider - Desktop";
                return;
            case '1':
                window.CE_SNAPSHOT_NAME = " HP - 2 - Metiers - Desktop";
                return;
            case '2':
                window.CE_SNAPSHOT_NAME = " HP - 3 - Réalisations - Desktop";
                return;
            case '3':
                window.CE_SNAPSHOT_NAME = " HP - 4 - Carrières - Desktop";
                return;
            case '4':
                window.CE_SNAPSHOT_NAME = " HP - 5 - Youtube - Desktop";
                return;
            case '5':
                window.CE_SNAPSHOT_NAME = " HP - 6 - RS - Desktop";
                return;
            default :
                return;
        }
    }
}


export default slider;



// WEBPACK FOOTER //
// ./src/scripts/components/slider.js